import {
    InteractionRequiredAuthError,
    LogLevel,
    PublicClientApplication,
} from '@azure/msal-browser'
import { APP_NAME } from '../constants/app-name'

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_MSAL_CLIENT_ID ?? '',
        redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI,
        authority: process.env.REACT_APP_MSAL_AUTHORITY ?? '',
        postLogoutRedirectUri: `${window.location.origin}${APP_NAME}`,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        iframeHashTimeout: 10000,
        loggerOptions: {
            logLevel: LogLevel.Trace,
            loggerCallback: (level: any, message: any, containsPii: any) => {
                if (containsPii) {
                    return
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message)
                        return
                    case LogLevel.Info:
                        console.info(message)
                        return
                    case LogLevel.Verbose:
                        console.debug(message)
                        return
                    case LogLevel.Warning:
                        console.warn(message)
                        return
                }
            },
        },
    },
}

export const msalInstance = new PublicClientApplication(msalConfig)

export async function acquireAccessToken(username?: string) {
    const scope: string = process.env.REACT_APP_MSAL_SCOPE ?? ''
    const request: any = {
        scopes: [scope],
    }
    if (username) {
        const user = msalInstance.getAccountByUsername(username)
        request.account = user
    }

    try {
        return await acquireToken(request)
    } catch (error: any) {
        throw error;
    }
}

export async function acquireGraphToken(username?: string) {
    const request: any = {
        scopes: ['https://graph.microsoft.com/.default'],
    }
    if (username) {
        const user = msalInstance.getAccountByUsername(username)
        request.account = user
    }

    try {
        return await acquireToken(request)
    } catch (error: any) {
        throw error;
    }
}

export async function acquireToken(request: any) {
    return new Promise((resolve, reject) => {
        if (!request.account) {
            msalInstance.acquireTokenRedirect(request)
                .then(() => {
                    reject(new Error('redirect_initiated'))
                })
                .catch((error) => {
                    reject(error instanceof Error ? error : new Error(String(error)));
                });
        } else {
            msalInstance
                .acquireTokenSilent(request)
                .then((tokenResponse) => {
                    resolve(tokenResponse)
                })
                .catch(async (error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        msalInstance
                            .acquireTokenRedirect(request)
                            .then(() => {
                                reject(new Error('redirect_initiated'))
                            })
                            .catch((redirectError) => {
                                reject(redirectError instanceof Error ? redirectError : new Error(String(redirectError)));
                            });
                    } else {
                        reject(error instanceof Error ? error : new Error(String(error)));
                    }
                })








        }
    })
}

export function getActiveAccount() {
    if (msalInstance.getActiveAccount()) return msalInstance.getActiveAccount()
    else if (msalInstance.getAllAccounts().length > 0)
        return msalInstance.getAllAccounts()[0]

    return null
}

/**
 * Clears stuck MSAL interaction state from localStorage and sessionStorage
 * This helps prevent infinite redirect loops when MSAL gets stuck
 */
export function clearMsalInteractionState() {
    // Clear MSAL interaction state flags
    window.localStorage.removeItem('msal.interaction.status');
    window.localStorage.removeItem('msal.request.params');
    window.localStorage.removeItem('msal.request.login');
    window.sessionStorage.removeItem('msal.interaction.status');
    window.sessionStorage.removeItem('msal.request.params');
    window.sessionStorage.removeItem('msal.request.login');
    console.warn('Cleared stuck MSAL interaction state');
}